import { Controller } from "@hotwired/stimulus";
import ApexCharts from "apexcharts";

export default class extends Controller {
  static targets = ["element"];
  static values = {
    labels: Array,
    series: Array,
  };

  connect() {
    window.HSStaticMethods.autoInit();

    console.log("Query Breakdown Controller connected");
    console.log("Series Value:", this.seriesValue);
    console.log("Labels Value:", this.labelsValue);
    var options = {
      series: this.seriesValue,
      labels: this.labelsValue,
      chart: {
        height: 300,
        type: "pie",
      },
      colors: [
        "#735dff",
        "#ff5a29",
        "rgb(12, 199, 99)",
        "#0ca3e7",
        "rgb(255, 154, 19)",
      ],
      legend: {
        position: "bottom",
        markers: {
          size: 4,
          strokeWidth: 0,
          strokeColor: "#fff",
          fillColors: undefined,
          radius: 12,
          customHTML: undefined,
          onClick: undefined,
          offsetX: 0,
          offsetY: 0,
        },
      },
      dataLabels: {
        dropShadow: {
          enabled: false,
        },
      },
    };

    var chart1 = new ApexCharts(this.elementTarget, options);

    chart1.render();
  }
}
